import { useAtom } from 'jotai'
import { accountModalAtom } from '../../Pages/Create/Create'
import { CONSTANTS } from '../../constants'
import { useProcessedSubtopics } from '../../Pages/Create/hooks'
import { FEATURE_FLAGS, useFreeWordLimit } from '../../hooks/featureFlags'
import { selectDocumentState } from '../../redux/docSlice'
import { DocumentState } from '../../redux/types'
import { useSelector } from 'react-redux'
import Button from '../Buttons'
import { LuArrowRight, LuZap } from 'react-icons/lu'
import { useAuth } from '../../contexts/Auth'
import { useFeatureFlagVariantKey } from 'posthog-js/react'

const DocumentBlur = ({ docId }: { docId: string }) => {
	const documentState: DocumentState = useSelector((state) => selectDocumentState(state, docId))
	const [, setAccountModalState] = useAtom(accountModalAtom)
	const freeWordLimit = useFreeWordLimit()
	const processedSubtopics = useProcessedSubtopics()
	const { currentUser } = useAuth() as any

	return (
		<div
			className="overflow-hidden relative md:h-[450px] h-[500px] mt-5"
			onClick={() => {
				if (!currentUser) {
					setAccountModalState((prev) => ({ ...prev, loginModalOpen: true }))
				} else {
					setAccountModalState((prev) => ({ ...prev, subscriptionModalOpen: true }))
				}
			}}
		>
			<div className="blur-sm pl-1">
				{documentState.userWriterSelections?.wordCount > CONSTANTS.TOPIC_GENERATION_BREAKPOINT && (
					<div className="text-2xl">{freeWordLimit > 250 ? processedSubtopics[2] : processedSubtopics[1]}</div>
				)}
				<div className="text-xl leading-[1.6] mt-2 h-52 select-none opacity-50 max-h-[350px] overflow-hidden">
					Lorem ipsum odor amet, consectetuer adipiscing elit. Facilisis semper velit curabitur dignissim augue quisque
					suspendisse aenean. Ipsum eu proin commodo a dolor ad maecenas et. Sed aptent purus platea leo est conubia
					dictum nascetur? Vivamus dapibus consequat nibh pulvinar aenean. Non vestibulum turpis gravida morbi porta
					hendrerit fusce. Vivamus dapibus consequat nibh pulvinar aenean. Non vestibulum turpis gravida morbi porta
					hendrerit fusce. Vivamus dapibus consequat nibh pulvinar aenean. Non vestibulum turpis gravida morbi porta
					hendrerit fusce.Vivamus dapibus consequat nibh pulvinar aenean. Non vestibulum turpis gravida morbi porta
					hendrerit fusce. Vivamus dapibus consequat nibh pulvinar aenean. Non vestibulum turpis gravida morbi porta
					hendrerit fusce.
				</div>
			</div>
			<div className="absolute bottom-0 flex items-center justify-center flex-col gap-3 py-9 px-3 w-full my-8 overflow-hidden rounded-xl border border-primary/20 bg-gradient-to-r from-[#eff6ff] to-[#eef2ff] shadow-lg">
				<div className="text-2xl font-semibold text-center">
					Unlock your full essay and go <span className="fancy-font font-normal">AI-undetectable</span>
				</div>
				<div className="text-lg text-gray-700 max-w-[650px] text-center">
					Get access to your entire essay, unlimited humanizing, unlimited essay generations, and smart autocomplete.
				</div>
				<Button
					type="default"
					className={`border border-primary px-9 py-2 bg-primary text-white font-semibold border-dotted mt-4`}
				>
					<div className="flex items-center gap-2">
						<div>Upgrade</div>
						{LuArrowRight({ className: 'w-5 h-5' })}
					</div>
				</Button>
			</div>
		</div>
	)
}

export default DocumentBlur
